export function deriveDetailStatusChange({
  nextStatus,
  activeDateRead,
  draftEndDate,
  fromNextUp = false,
  currentRereadStartDate = "",
  dnfLabel = "DNF",
  today,
}) {
  const isUnreadStatus = nextStatus === "Unstarted" || nextStatus === "Unread";
  const hasCompletedHistory = !!(activeDateRead || draftEndDate);

  if (isUnreadStatus) {
    return {
      status: nextStatus,
      startDate: "",
      endDate: "",
      rating: 0,
      rereading: false,
      rereadStartDate: "",
    };
  }

  if (nextStatus === "In Progress" && hasCompletedHistory && !fromNextUp) {
    return {
      status: nextStatus,
      rereading: true,
      rereadStartDate: currentRereadStartDate || today,
    };
  }

  return {
    status: nextStatus,
    rereading: false,
    rereadStartDate: "",
    endDate:
      nextStatus !== "Read" && nextStatus !== dnfLabel && nextStatus !== "DNF"
        ? ""
        : undefined,
  };
}

export function resolveDetailStatusFields({
  active,
  dStatus,
  dRating,
  dStartDate,
  dEndDate,
  dReads,
  dRereading,
  dRereadStartDate,
  dnfLabel = "DNF",
  today,
}) {
  const preservingCompletedHistory = dRereading && dStatus === "In Progress";
  const resetReadingProgress = dStatus === "Unstarted" || dStatus === "Unread";
  const resolvedDetailStatus =
    resetReadingProgress
      ? dStatus
      : !preservingCompletedHistory && dEndDate && dStatus !== dnfLabel && dStatus !== "DNF"
        ? "Read"
        : dStatus;
  const normalizedRereadStartDate =
    preservingCompletedHistory ? dRereadStartDate || today : null;

  return {
    rating: resetReadingProgress ? 0 : dRating,
    status: resolvedDetailStatus,
    dateStarted: resetReadingProgress
      ? null
      : preservingCompletedHistory
        ? active.dateStarted || dStartDate || null
        : dStartDate || null,
    dateRead: resetReadingProgress
      ? null
      : preservingCompletedHistory
        ? active.dateRead || dEndDate || null
        : resolvedDetailStatus === "Read" || resolvedDetailStatus === dnfLabel
          ? dEndDate || active.dateRead || null
          : null,
    rereading: !!normalizedRereadStartDate,
    rereadStartDate: normalizedRereadStartDate,
    reads: dReads,
  };
}

export function buildFinishReadingState({
  book,
  dRereading,
  dRereadStartDate,
  dReads,
  today,
  readingDays,
}) {
  const isRereadSession = !!(
    book.rereading ||
    dRereading ||
    book.rereadStartDate ||
    dRereadStartDate
  );

  if (isRereadSession) {
    const rereadStartedOn = book.rereadStartDate || dRereadStartDate || today;
    const rereadDays = readingDays(rereadStartedOn, today);
    const nextReads = [
      ...(Array.isArray(book.reads) ? book.reads : Array.isArray(dReads) ? dReads : []),
      {
        started: rereadStartedOn,
        finished: today,
        days: rereadDays,
        date: today,
        note: "",
      },
    ];

    return {
      isRereadSession: true,
      updated: {
        ...book,
        status: "Read",
        rereading: false,
        rereadStartDate: null,
        reads: nextReads,
      },
      startedOn: rereadStartedOn,
      nextReads,
    };
  }

  const startedOn = book.dateStarted || today;
  return {
    isRereadSession: false,
    startedOn,
    updated: {
      ...book,
      status: "Read",
      dateStarted: startedOn,
      dateRead: today,
      rereading: false,
      rereadStartDate: null,
    },
  };
}

export function hasCompletedReadHistory(book) {
  if (!book?.dateRead) return false;
  return (
    book.status === "Read" ||
    !!book.rereading ||
    !!book.rereadStartDate
  );
}
